import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import FormattedListValue from '@/shared/components/FormattedListValue';
import classNames from 'classnames';
import messages from '../taskMessages';
import TaskStatusToggle from '../TaskStatusToggle';

const TaskDetailsSubtasks = ({
  task,
  intl,
  openTaskDetails,
  onTasksUpdated,
  onShowHistory,
  historyActive,
}) => {
  if (!task.children || task.children.length <= 0) return null;

  return (
    <div className="task-detail-section taskDetail--subtaskList">
      <label>
        <b>
          {intl.formatMessage(messages.ThisTaskHasCountSubTasks, {
            count: task.children.length,
          })}
        </b>
      </label>
      {!historyActive && (
        <a className="btn btn-default btn-xs pull-right show-history-btn" onClick={onShowHistory}>
          <i className="fa fa-history margin5R" />

          <span>{intl.formatMessage(messages.ShowHistory)}</span>
        </a>
      )}

      <table>
        <tbody>
          {task.children.map(subtask => (
            <tr key={subtask.id}>
              <td className="status-column">
                <TaskStatusToggle
                  id={`TaskStatusToggle-${task.id}-${subtask.id}`}
                  value={{
                    id: subtask.id,
                    status: subtask.status,
                    isBlocked: subtask.isBlocked,
                    inapplicable: subtask.inapplicable,
                    rejected: subtask.rejected,
                    taskLevel: 1,
                  }}
                  onTasksUpdated={onTasksUpdated}
                  onOpenDetail={openTaskDetails}
                  title={intl.formatMessage(messages.ChangeSubtaskStatus)}
                />
              </td>
              <td className="taskname-column">
                <span
                  className={classNames('text-clickable', {
                    strike: subtask.inapplicable || subtask.rejected,
                  })}
                  title={intl.formatMessage(messages.ViewTask)}
                  onClick={() => openTaskDetails(subtask.id)}
                >
                  {subtask.name && subtask.name}
                  {!subtask.name && (
                    <FormattedListValue
                      list="tasktemplate"
                      id={subtask.templateId}
                      fallback={subtask.name || subtask.templateName || subtask.taskTemplateId}
                    />
                  )}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

TaskDetailsSubtasks.propTypes = {
  task: PropTypes.shape({
    relation: PropTypes.object,
    id: PropTypes.string,
  }).isRequired,
  openTaskDetails: PropTypes.func.isRequired,
  onTasksUpdated: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  onShowHistory: PropTypes.func.isRequired,
  historyActive: PropTypes.bool.isRequired,
};

export default injectIntl(TaskDetailsSubtasks);
